import { render, staticRenderFns } from "./BankTransferFilesEditDialog.vue?vue&type=template&id=6ab87ebd&scoped=true&"
import script from "./BankTransferFilesEditDialog.vue?vue&type=script&lang=js&"
export * from "./BankTransferFilesEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferFilesEditDialog.vue?vue&type=style&index=0&id=6ab87ebd&lang=scss&scoped=true&"
import style1 from "./BankTransferFilesEditDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab87ebd",
  null
  
)

export default component.exports